/* eslint-disable import/prefer-default-export */
/* eslint-disable func-names */
import { PRC_FOR_FTU, PRC_FOR_SUBSCRIBED } from 'constants/index';
import { isPrimeUser } from 'utils/common';
import { getPrcCookieValue } from '../../utils/primeUtil';
import Cookie from '../../utils/cookies';

export function initiBeat() {
  window.TimesApps = window.TimesApps || {};
  const { TimesApps } = window;
  TimesApps.iBeat = (function() {
    let jsLoaded = false;
    let jsLoadInitialized = false;
    let callQueue = [];
    const defaultConfig = {
      host: 'timesofindia.indiatimes.com',
      key: 'ae9d3286a3123c65177df0aa6088b6e7',
      domain: 'timesofindia.indiatimes.com',
    };

    const _setPageParams = params => {
      if (typeof params !== 'object') {
        return;
      }
      window._page_config = { ...defaultConfig, ...params };
    };

    const _sendIbeatCall = params => {
      _setPageParams(params);
      if (
        typeof window.iBeatPgTrend !== 'undefined' &&
        typeof window.iBeatPgTrend.init === 'function'
      ) {
        window.iBeatPgTrend.init();
      }
    };

    const _moveToIbeatQueue = params => {
      callQueue.push(params);
    };

    const _emptyIBeatQueue = () => {
      for (let i = 0; i < callQueue.length; i += 1) {
        _sendIbeatCall(callQueue[i]);
      }

      callQueue = [];
    };
    const setWindowIbeatTrack = () => {
      const prcValue = getPrcCookieValue();
      const loginType = Cookie.get('LoginType');
      const isSubscribed =
        prcValue &&
        (prcValue === PRC_FOR_FTU || prcValue === PRC_FOR_SUBSCRIBED);
      if (typeof window !== 'undefined') {
        window._ibeat_track = window._ibeat_track || {};
        if (isPrimeUser() || isSubscribed) {
          window._ibeat_track = {
            ...window._ibeat_track,
            visitor_cat: 1,
          };
        } else if (
          window.sessionStorage &&
          window.sessionStorage.getItem('inGracePeriod') !== null &&
          loginType &&
          loginType === 'sso' &&
          !(isPrimeUser() || isSubscribed)
        ) {
          window._ibeat_track = {
            ...window._ibeat_track,
            visitor_cat: 2,
          };
        } else {
          window._ibeat_track = {
            ...window._ibeat_track,
            visitor_cat: 3,
          };
        }
      }
    };
    const _set_ibeatJsScriptOnPage = () => {
      jsLoadInitialized = true;
      const script = document.createElement('script');
      // script.src =
      // 'https://agi-static.indiatimes.com/cms-common/stg/stg-ibeat.min.js';
      script.src = 'https://agi-static.indiatimes.com/cms-common/ibeat.min.js';
      script.async = true;
      script.onload = () => {
        jsLoaded = true;
        _emptyIBeatQueue();
      };
      if (
        document.getElementsByTagName('head') &&
        document.getElementsByTagName('head')[0]
      ) {
        document.getElementsByTagName('head')[0].appendChild(script);
      }
      // document.body.appendChild(script);
    };
    const _loadJs = () => {
      _set_ibeatJsScriptOnPage();
      window._ibeat_track = window._ibeat_track || {};
      // if (
      //   window.TimesGDPR &&
      //   window.TimesGDPR.common.consentModule.gdprCallback
      // ) {
      //   window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
      //     if (dataObj.isEUuser) {
      //       window._ibeat_track = {
      //         sCookie: false,
      //       };
      //     }
      //   });
      // }
    };

    const fn = {
      sendIBeatCall() {
        setWindowIbeatTrack();
        if (jsLoaded) {
          _sendIbeatCall();
        } else if (!jsLoaded && jsLoadInitialized) {
          _moveToIbeatQueue();
        } else {
          _setPageParams();
          _loadJs();
        }
      },
    };

    return fn;
  })();
}
